module.exports = __webpack_public_path__ + "img/09产废.0932b9e3.jpg";